import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { MenuItem, Select, Typography, OutlinedInput } from '@mui/material';
import { useAtomValue } from 'jotai';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import { userBranchesAtom } from '../../Atoms';
// import IconButton from '../Button/IconButton';
// import BranchesMenu from '../../Pages/UserManagement/Components/BranchesMenu';

const styles = {
  select: {
    mb: '16px',
    '& .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #d6d6d6',
      borderRadius: '10px',
    },
  },
  fieldCaption: {
    color: 'greys.title',
    fontSize: '1rem',
  },
};

const BranchSelect = function BranchSelect({
  // sidebarOpen,
  handleChangeBranch = () => {},
}) {
  const intl = useIntl();
  const userBranches = useAtomValue(userBranchesAtom);
  // const [branchesMenu, setBranchesMenu] = useState(null);
  const [value, setValue] = useState(
    sessionStorage.getItem('selectedBranch')
      ? JSON.parse(sessionStorage.getItem('selectedBranch'))?.id
      : userBranches?.find((x) => x?.isDefault)?.id
  );

  /*   const openBranchesMenu = (event) => {
    setBranchesMenu(event.currentTarget);
  };
  const handleCloseBranchesMenu = () => {
    setBranchesMenu(null);
  }; */

  const onChange = (event) => {
    setValue(event.target.value);
    if (event.target.value)
      handleChangeBranch(
        userBranches?.find((x) => x?.id === event.target.value)
      );
  };

  /* !sidebarOpen ? (
    <>
      <IconButton
        title="BRANCH"
        onClick={openBranchesMenu}
        tooltipProps={{ placement: 'right' }}
        iconProps={{ sx: { padding: 'unset' } }}
      >
        <BusinessRoundedIcon />
      </IconButton>
      <BranchesMenu
        anchor={branchesMenu}
        onClose={handleCloseBranchesMenu}
        branches={userBranches}
        onClickBranch={handleChangeBranch}
      />
    </>
  ) : ( */
  return (
    <>
      <Typography variant="subtitle2" sx={styles.fieldCaption}>
        {intl.messages.BRANCH}
      </Typography>
      <Select
        id="branch-select"
        value={value}
        onChange={onChange}
        fullWidth
        IconComponent={KeyboardArrowDownIcon}
        input={<OutlinedInput sx={styles.select} />}
      >
        {userBranches.map(({ id, branchDescription }) => (
          <MenuItem key={id} value={id}>
            {branchDescription}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

BranchSelect.propTypes = {
  handleChangeBranch: PropTypes.func,
};

export default BranchSelect;
